import { useTranslations } from 'next-intl'
import { cx } from 'class-variance-authority'
import { ChatTextIcon } from '@phosphor-icons/react/dist/ssr/ChatText'
//

import { useDrawerRegistry } from '@/components/drawers/drawer.provider'
import { NumberBadge } from '@/components/atoms'
import { usePendingReviewsCount } from '@/services/queries/review'
import { REVIEW_DRAWER_CLASSNAME } from '@/utils/reviews'

export const ReviewsNotifications = ({ component = '' }) => {
  const t = useTranslations('Navigation')
  const { data: pendingReviewsCount = 0 } = usePendingReviewsCount()
  const { openDrawer, close, isOpen, isSuspended } = useDrawerRegistry()

  const count = pendingReviewsCount
  const hasActiveReviews = component !== 'navbar' && count > 0

  const openPanel = () =>
    openDrawer('reviews', {
      title: t('reviewNotifications.title'),
      className: REVIEW_DRAWER_CLASSNAME,
    })

  const toogleDrawer = () => {
    if (isSuspended) return
    if (isOpen) close()
    else openPanel()
  }

  return (
    <button
      className={cx(
        'relative grid size-10 place-content-center rounded-full transition-colors',
        {
          'grid bg-transparent text-border ring-offset-black hover:bg-slate-800 mdh:hidden':
            component === 'navbar',
          'bg-neutral-100 text-slate-500 ring-offset-white hover:text-slate-300':
            component !== 'navbar' && !hasActiveReviews,
          'text-slate-800': hasActiveReviews,
          'outline-none ring-2 ring-primary-500': isOpen,
        },
      )}
      onClick={toogleDrawer}
      disabled={isSuspended}
    >
      {hasActiveReviews && (
        <span className="absolute inset-0.5 rounded-full bg-orange-500 ring-1 ring-inset ring-primary-700/20" />
      )}
      <ChatTextIcon className="relative z-10 size-6" />
      <NumberBadge count={count} />
    </button>
  )
}
